import { useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import type { Swiper as SwiperType } from 'swiper';
import { useRouteHook } from '@shared/hooks';
import { cn, RoutePaths } from '@shared/utils';
import type { GetProductsResponse } from '@shared/api';
import { Button, Spinner } from '@shared/widgets';
import ArrowIcon from '@assets/images/arrow.svg';
import cardImg from '@assets/images/right.png';
import 'swiper/css';

let swiperControl: SwiperType | null = null;

interface ICardInfoProps {
  className?: string;
  cards: GetProductsResponse[];
  shownCard: number;
  onChange: (swiper: SwiperType) => void;
  onSwiper: (swiper: SwiperType) => void;
}

export const CardInfo = (props: ICardInfoProps) => {
  const { navigate } = useRouteHook();

  useEffect(() => {
    return () => {
      swiperControl = null;
    };
  }, []);

  return (
    <div className={cn('relative mx-auto flex min-h-[387px] max-w-[1100px] items-start justify-center', props.className)}>
      {!!props.cards.length && (
        <div className='max-md:max-w-auto relative max-w-[421px] pr-[50px] max-md:px-15'>
          <div
            className={cn(
              'absolute top-[-10%] left-[-8%] flex h-full rotate-180 cursor-pointer items-center justify-center max-md:top-0 max-md:left-0 max-md:w-[60px]',
              props.shownCard === 0 && 'opacity-20',
            )}
            onClick={() => props.shownCard > 0 && swiperControl?.slideTo(props.shownCard - 1)}
          >
            <ArrowIcon />
          </div>
          <Swiper
            className='h-[373px] max-w-[376px] max-md:h-auto max-md:max-w-full'
            spaceBetween={0}
            slidesPerView={1}
            onSlideChange={props.onChange}
            onSwiper={(sw) => {
              props.onSwiper(sw);
              swiperControl = sw;
            }}
          >
            {props.cards?.map((_, idx) => (
              <SwiperSlide key={idx}>
                {idx === props.shownCard ? (
                  <img
                    src={
                      (props.cards?.[props.shownCard]?.images?.rotated && `${process.env.API_URL}/${props.cards[props.shownCard].images.rotated}`) ||
                      cardImg
                    }
                    alt='card'
                  />
                ) : (
                  <div className='flex h-full w-full items-center justify-center'>
                    {!!props.shownCard || props.shownCard === 0 ? (
                      <div className='ml-2 h-[25px]'>
                        <Spinner />
                      </div>
                    ) : (
                      <div className='mt-6 font-light text-[#4c4c4c] max-md:m-0 max-md:mb-6 max-md:text-[#4c4c4c80]'>please select card</div>
                    )}
                  </div>
                )}
              </SwiperSlide>
            ))}
          </Swiper>
          <div
            className={cn(
              'absolute top-[-10%] right-[20px] flex h-full cursor-pointer items-center justify-center max-md:top-0 max-md:right-0 max-md:w-[60px]',
              props.shownCard === props.cards.length - 1 && 'opacity-20',
            )}
            onClick={() => props.shownCard < props.cards.length - 1 && swiperControl?.slideTo(props.shownCard + 1)}
          >
            <ArrowIcon />
          </div>
        </div>
      )}
      <div className='ml-[92px] flex max-w-[396px] shrink-0 basis-[50%] flex-col justify-center max-md:m-0 max-md:p-4'>
        <div className='font-[Prata] text-3xl text-[#272727] max-md:mb-2'>{props.cards?.[props.shownCard]?.name}</div>
        <div className='mt-6 font-light text-[#4c4c4c] max-md:m-0 max-md:mb-6 max-md:text-[#4c4c4c80]'>
          {props.cards?.[props.shownCard]?.description}
        </div>
        <div className='mt-[85px] flex justify-between gap-4 max-md:m-0'>
          <Button fullWidth onClick={() => navigate(RoutePaths.form.onNavigate(), { state: { selectedCard: props.cards[props.shownCard] } })}>
            Apply Now
          </Button>
          <Button fullWidth color='outlined' onClick={() => navigate(RoutePaths.tariff.onNavigate())}>
            Tariff of Charges
          </Button>
        </div>
      </div>
    </div>
  );
};
